import { MenuGroup } from '@fiverr-private/dropdown';

export default MenuGroup;
